<template lang="pug">
    section#listagem
        .wrapper
            ul
                li(v-for="noticia in listagem.data")
                    router-link(:to="{name:'noticia', params: {slug: noticia.slug}}")
                        article
                            header
                                img.lazy(:src="noticia.thumb_link", :alt="noticia.titulo")
                                h3 {{noticia.titulo}}
                                time(:datetime='noticia.published_at') {{noticia.date}}
                            main
                                blockquote {{noticia.resumo}}
                            footer.articleFooter
                                span [+] Leia mais

            div.paginacao(v-if="listagem.current_page <= listagem.last_page")
                router-link(:to="{name:'noticias'}").pagina Carregar mais notícias
</template>

<script>


export default {
    name: "section-listagem",
    props:{
        listagem: Object
    }
}
</script>

<style lang="stylus" scoped src="./Listagem.styl"></style>